module.exports = __webpack_public_path__ + "img/login-v2-dark.02cdba14.svg";